import React from 'react';
import {borderBottomStyle, borderSideStyle} from "./tableStyles";

type Props = {}

const SimulationTableColumnTitles: React.VFC<Props> = (props) => {
  return (
    <tr>
      <td className={'py-1 px-3 whitespace-nowrap ' + borderBottomStyle}><p>1試合</p></td>
      <td className={'py-1 px-3 whitespace-nowrap ' + borderBottomStyle + borderSideStyle}><p>2試合</p></td>
      <td className={'py-1 px-2 whitespace-nowrap ' + borderBottomStyle + borderSideStyle}><p>合計</p></td>
      <td className={'py-1 px-2 whitespace-nowrap ' + borderBottomStyle + borderSideStyle}><p>残球</p></td>
      <td className={'py-1 px-2 whitespace-nowrap ' + borderBottomStyle + borderSideStyle}>登板可否</td>
      <td className={'py-1 px-3 whitespace-nowrap ' + borderBottomStyle}><p>1試合</p></td>
      <td className={'py-1 px-3 whitespace-nowrap ' + borderBottomStyle + borderSideStyle}><p>2試合</p></td>
      <td className={'py-1 px-2 whitespace-nowrap ' + borderBottomStyle + borderSideStyle}><p>合計</p></td>
      <td className={'py-1 px-2 whitespace-nowrap ' + borderBottomStyle + borderSideStyle}><p>残球</p></td>
      <td className={'py-1 px-2 whitespace-nowrap ' + borderBottomStyle + borderSideStyle}>登板可否</td>
      <td className={'py-1 px-3 whitespace-nowrap ' + borderBottomStyle}><p>1試合</p></td>
      <td className={'py-1 px-3 whitespace-nowrap ' + borderBottomStyle + borderSideStyle}><p>2試合</p></td>
      <td className={'py-1 px-2 whitespace-nowrap ' + borderBottomStyle + borderSideStyle}><p>合計</p></td>
      <td className={'py-1 px-2 whitespace-nowrap ' + borderBottomStyle + borderSideStyle}><p>残球</p></td>
      <td className={'py-1 px-2 whitespace-nowrap ' + borderBottomStyle + borderSideStyle}>登板可否</td>
      <td className={'py-1 px-3 whitespace-nowrap ' + borderBottomStyle}><p>1試合</p></td>
      <td className={'py-1 px-3 whitespace-nowrap ' + borderBottomStyle + borderSideStyle}><p>2試合</p></td>
      <td className={'py-1 px-2 whitespace-nowrap ' + borderBottomStyle + borderSideStyle}><p>合計</p></td>
      <td className={'py-1 px-2 whitespace-nowrap ' + borderBottomStyle + borderSideStyle}><p>残球</p></td>
      <td className={'py-1 px-2 whitespace-nowrap ' + borderBottomStyle + borderSideStyle}>登板可否</td>
    </tr>
  );
};

export default SimulationTableColumnTitles;
